module.exports = __webpack_public_path__ + "static/media/plugo-logo.98ac4f83.png";